
import {
    ADD_LEAD_HOME,
    ADD_LEAD_HOME_SUCCESS,
    ADD_LEAD_HOME_ERROR,
    UPDATE_LEAD_HOME,
    UPDATE_LEAD_HOME_SUCCESS,
    UPDATE_LEAD_HOME_ERROR,
    DELETE_LEAD_HOME,
    DELETE_LEAD_HOME_SUCCESS,
    DELETE_LEAD_HOME_ERROR,

} from "./actionTypes"
export const addLeadHome = payload => {
    return {
        type: ADD_LEAD_HOME,
        payload: payload,
    }
}

export const addLeadHomeSuccess = lead => {
    return {
        type: ADD_LEAD_HOME_SUCCESS,
        payload: lead,
    }
}

export const addLeadHomeError = error => {
    return {
        type: ADD_LEAD_HOME_ERROR,
        payload: error,
    }
}

export const updateLeadHome = payload => {
    return {
        type: UPDATE_LEAD_HOME,
        payload: payload,
    }
}

export const updateLeadHomeSuccess = lead => {
    return {
        type: UPDATE_LEAD_HOME_SUCCESS,
        payload: lead,
    }
}

export const updateLeadHomeError = error => {
    return {
        type: UPDATE_LEAD_HOME_ERROR,
        payload: error,
    }
}

export const deleteLeadHome = payload => {
    return {
        type: DELETE_LEAD_HOME,
        payload: payload,
    }
}

export const deleteLeadHomeSuccess = lead => {
    return {
        type: DELETE_LEAD_HOME_SUCCESS,
        payload: lead,
    }
}

export const deleteLeadHomeError = error => {
    return {
        type: DELETE_LEAD_HOME_ERROR,
        payload: error,
    }
}

  //Lead Homes//